var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    {
      attrs: { disabled: _vm.disabled, title: _vm.title },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c("v-switch", {
                staticClass: "mt-0 mr-5",
                attrs: {
                  label: "Enabled",
                  color: "success",
                  "hide-details": "",
                },
                nativeOn: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
                model: {
                  value: _vm.value.enabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "enabled", $$v)
                  },
                  expression: "value.enabled",
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "3", sm: "3" } },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    label: "Feature Duration",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.value.duration,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.value,
                                        "duration",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "value.duration",
                                  },
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("dt", [_vm._v("Lower Cap feature duration")]),
                  _c("dt", [_vm._v("0 - UNLIMITED")]),
                ]
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "3", sm: "3" } },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    label: "Collect Data Duration",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.value.collectDataDuration,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.value,
                                        "collectDataDuration",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "value.collectDataDuration",
                                  },
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("dt", [
                    _vm._v(
                      "Amount of seconds that the feature will collect data before assign a segment"
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "3", md: "3" } },
            [
              _c("r-range", {
                attrs: {
                  model: _vm.value.sinkCount,
                  label: "Sink Count",
                  labelFrom: "Min Value",
                  labelTo: "Max Value",
                  "hide-details": "",
                },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "sinkCount", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "3", md: "3" } },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    label: "Sink Price",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.value.sinkPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.value,
                                        "sinkPrice",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "value.sinkPrice",
                                  },
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("dt", [
                    _vm._v(
                      "The maximum price a player pays to continue playing in PTHs that allow them to join a lower-cap segment"
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-8", attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "12", md: "12" } },
            [
              _c("r-currency-table", {
                attrs: {
                  items: _vm.value.defaultPrice,
                  title: "Default Price",
                },
                on: {
                  "update:items": function ($event) {
                    return _vm.$set(_vm.value, "defaultPrice", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "12", md: "12" } },
            [
              _c("r-currency-table", {
                attrs: { items: _vm.value.lowerPrice, title: "Lower Price" },
                on: {
                  "update:items": function ($event) {
                    return _vm.$set(_vm.value, "lowerPrice", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }